<template>
	<div class="footer">
		<div class="Fcenter">
			<div class="about">
				<h1 class="aboutYi">关于以诺</h1>
        <ul class="zhAbout">
          <li><router-link to="/AboutEnoch">以诺源起</router-link></li>
          <li><router-link to="/AboutEnoch">校长寄语</router-link></li>
        </ul>
        <ul class="send zhAbout">
          <li><router-link to="/AboutEnoch">愿景与使命</router-link></li>
          <li><router-link to="/AboutEnoch">我们的服务</router-link></li>
        </ul>
			</div>
			<div class="contactOur">
				<h1 class="aboutYi">联系我们</h1>
				<p class="dizhi"><Icon type="ios-location" class="juli"></Icon>上海市杨浦区长阳路1687号长阳创谷2号楼</p>
				<p><Icon type="ios-email" class="juli"></Icon>enoch.service@noahwm.com</p>
			</div>
			<div class="contactPh">
				<p class="phonenumber">400-820-0025-3</p>
				<p class="timershow">周一至周五9:00-18:00</p>
			</div>
			<div class="QR">
				<img src="../../assets/QR.jpg" class="footQR"/>
				<p>扫一扫，关注我们</p>
			</div>
			<div class="clears"></div>
			<p class="foot">以诺教育培训（上海）有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Copyright ©  2017-2020<a href="http://www.miitbeian.gov.cn/">沪ICP备15049725号-1</a><img src="../../assets/wangjing.jpg" class="wangjing" title="亲爱的市民朋友，上海警方反诈劝阻电话“962110”系专门针对避免您财产被骗受损而设，请您一旦收到来电，立即接听"></p>
		</div>
	</div>
</template>
<script>
	export default{
		name:"Bottom",
    mounted(){
      $(".zhAbout li").click(function(){
        $(document).scrollTop(0)
      })
    },
	}
</script>

<style scoped>
	.footer{width:100%;height:235px;background:#303030;margin-top: -235px;}
	.Fcenter{width:1160px;height:160px;margin:0 auto;border-bottom:1px solid #505050;}
	.about{width:172px;height:100%;float: left;}
	.aboutYi{color:#fff;font-size: 18px;padding-top:42px;}
	.juli{margin-right:12px;}
	.about ul{color:#aaa;float: left;margin-top:20px;}
	.send{margin-left:45px;}
	.about ul li{margin-bottom:10px;}
	.contactOur{float: left;margin:0 0 0 145px;}
	.contactOur p{color:#aaa;}
	.dizhi{margin:14px 0 10px 0;}
	.contactPh{width:245px;float:left;margin-left:165px;}
	.phonenumber{font-size: 30px;color:#fff;margin-top:42px;text-align:right;}
	.timershow{color:#aaa;margin:10px 0 0 0;text-align:right;}
	.QR{width:118px;float:right;}
	.QR p{color:#aaa;}
	.footQR{width:100px;height:100px;margin:20px 0 0 6px;}
	.foot{color:#aaa;margin-top:24px;position: relative;}
	.foot a{margin-left:20px;color: #aaa;}
	.clears{clear: both;}
  .zhAbout>li>a{color:#aaaaaa;}
	.wangjing {width: 100px;height: 60px;position: absolute;right: 12px;top:-15px;}
</style>



// WEBPACK FOOTER //
// Bottom.vue?f1a11b8e